import { render, staticRenderFns } from "./CreditorsAssembly.vue?vue&type=template&id=2cfead28&scoped=true"
import script from "./CreditorsAssembly.vue?vue&type=script&lang=js"
export * from "./CreditorsAssembly.vue?vue&type=script&lang=js"
import style0 from "./CreditorsAssembly.vue?vue&type=style&index=0&id=2cfead28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfead28",
  null
  
)

export default component.exports